import input from '@/components/input'
import { numericInputValidation } from '@/mixins/numericInputValidation'

export default {
  name: 'InputTextNumbers',
  extends: input,
  mixins: [numericInputValidation],

  props: {
    icon: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      validator: v => ['text', 'password'].indexOf(v) !== -1,
      default: 'text'
    },
    removeIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    inputmode: {
      type: String,
      required: false
    }
  },

  computed: {
    showRemoveIcon() {
      return this.removeIcon && this.value && this.value.length > 0
    }
  },

  methods: {
    handleInput(event) {
      let value = event.target.value
      
      if (this.shouldValidateNumericField(this.name)) {
        value = this.sanitizeNumericValue(value)
        event.target.value = value
      }
      
      this.$emit('input', value)
    },

    handleChange(event) {
      let value = event.target.value
      
      if (this.shouldValidateNumericField(this.name)) {
        value = this.sanitizeNumericValue(value)
        event.target.value = value
      }
      
      this.$emit('change', value)
    },

    handleKeydown(event) {
      if (this.shouldValidateNumericField(this.name)) {
        this.preventInvalidNumericKeys(event)
      }
    },

    cleanInitialValue() {
      if (this.shouldValidateNumericField(this.name)) {
        if (this.value === 0 || this.value === '0') {
          this.$emit('input', '')
        }
      }
    }
  },

  mounted() {
    this.cleanInitialValue()
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (this.shouldValidateNumericField(this.name)) {
          if (newVal === 0 || newVal === '0') {
            this.$nextTick(() => {
              this.$emit('input', '')
            })
          }
        }
      }
    }
  }
}